
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getToken, utc_local } from '../../../helpers/Helper';
import { post } from '../../../helpers/api_helper';
import { POST_GET_USER_DETAIL, POST_USER_SUBSCRIPTION_LIST, POST_USER_INVOICES_LIST, POST_PDF_INVOICE } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import Loader from '../../../components/Loader';

const UserRoles = (props) => {
    const navigate = useNavigate();
    const { id } = useParams()
    const [isLoader, setLoader] = useState(true);
    
    const [userInfo, SetUserInfo] = useState({});

    useMounted(() => {
        getUserDetail()
    })

    const getUserDetail = async () => {
        setLoader(true);
        var res_data = await post(POST_GET_USER_DETAIL, { 'userId': id });
        if (res_data.status) {
            SetUserInfo(res_data.data.user_detail);
            setLoader(false);

            setTimeout(() => {
                getSubscription()
                getInvoiceList()
            }, 500);
        } else {
            setLoader(false);
            toast.error(res_data.message);
            navigate("/admin/dashboard");
        }
    }

    const getSubscription = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [5] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.userCompanyId = id

                    $.ajax({
                        "url": POST_USER_SUBSCRIPTION_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "subscriptionId" },
                    { "data": "name" },
                    { "data": "totalEmployees" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.startDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.endDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className={`border-0 badge ${(data.status === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.status}</button>
                            </>)
                        }
                    },
                ]
            });
        }
    }

    const getInvoiceList = () => {
        const tableElement = $('#dataTableExampleInvoice');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [5,6] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.userCompanyId = id;

                    $.ajax({
                        "url": POST_USER_INVOICES_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "invoiceId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    { "data": "userName" },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                ₹{data.totalAmount}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.paymentStatus === 'Unpaid' && <span className='text-danger'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Paid' && <span className='text-success'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Canceled' && <span className='text-danger'>{data.paymentStatus}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <a href={`${POST_PDF_INVOICE}${data.invoiceId}`} target="_blank" rel="noreferrer" className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>
                                {/* {data.paymentStatus === 'Unpaid' && 
                                    <button  onClick={() => { navigate('/invoices/pay/' + data.invoiceId); }} className='btn btn-sm btn-success'>Pay</button>
                                } */}
                            </>)
                        }
                    },

                ]
            });
        }
    }
    
    return (
        <>
            {isLoader && <Loader />}
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>User Detail</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    <a href={`/?id=${userInfo.userId}`} className='btn btn-sm' rel="noreferrer" target="_blank"><i className="bx bx-log-in align-middle text-primary"></i></a>
                                </div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <b>Company Name </b><br />
                                    <p>{userInfo.companyName} </p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>User Name </b><br />
                                    <p>{userInfo.name}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>Mobile Nummber </b><br />
                                    <p>{userInfo.mobileNo}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>User Email </b><br />
                                    <p>{userInfo.email}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>Country Name</b><br />
                                    <p>{userInfo.countryName}</p>
                                </div>
                                {userInfo.userIpAddress && 
                                    <div className='col-sm-4'>
                                        <b>Ip Address</b><br />
                                        <a href={`https://check-host.net/ip-info?host=${userInfo.userIpAddress}`} className='text-primary' target="_blank" rel="noopener noreferrer">{userInfo.userIpAddress}</a>
                                    </div>
                                }
                            </div>

                            <hr />
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <h5 className='mt-1'>Subscriptions</h5>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='table-responsive text-nowrap'>
                                        <table id="dataTableExample" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Id</td>
                                                    <td>Name</td>
                                                    <td>Employees</td>
                                                    <td>StartDate</td>
                                                    <td>End Date</td>
                                                    <td>Status</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div className='row'>
                                <div className='col-6'>
                                    <h5 className='mt-1'>Invoices</h5>
                                </div>
                                <div className='col-6 text-right'>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='table-responsive text-nowrap'>
                                        <table id="dataTableExampleInvoice" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Invoice</td>
                                                    <td>Invoice Date</td>
                                                    <td>User Name</td>
                                                    <td>Plan Name</td>
                                                    <td>Total</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

      
        </>
    );
}

export default UserRoles;